const getEffectProperty = (effectName: string): string => {
  switch (effectName) {
    case "None":
      break;
    case "Rounded background":
    case "Straight background":
    case "Block background":
      return "background_color";
    case "Shadow":
      return "shadow_color";
    case "Outline":
    case "Outline & Filled":
      return "stroke_color";
    default:
      return "";
  }

  return "";
};

export default getEffectProperty;
